// extracted by mini-css-extract-plugin
export default {"MyForm":"MyForm_MyForm__P-w8y","toolbar":"MyForm_toolbar__Tc2GV"};